// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_d0-2";
export var aiChatCartContainerExit = "_d0-4";
export var aiChatContainerLarge = "_d0-0";
export var aiChatContainerSmall = "_d0-1";
export var aiChatIcon = "_d0-6";
export var slideInFromRight = "_d0-3";
export var slideOutToRight = "_d0-5";